import { CloudDownloadOutlined } from "@ant-design/icons";
import { Button, Modal, Progress, Tag, theme, Tooltip } from "antd";
import { useRef, useState, useEffect } from "react";
import { getCurrentUser } from "@/utils/storage";
import { ActionType, ProColumns, ProTable } from "@ant-design/pro-components";
import {
  postBaobPcDownloadTaskList,
  PostBaobPcDownloadTaskList200DataListItem,
  PostBaobPcDownloadTaskListBody,
} from "@/openapi/baob/pc.DownloadTask/api.client.axios";
import eventBus from "@/utils/eventBus";
import { EVENT_OPEN_DOWNLOAD_CENTER } from "@/constant/eventBus";
import { fileDownloadByWindowOpen } from "@/utils/file";

const HeaderDownload = () => {
  const { token: globalToken } = theme.useToken();
  const actionRef = useRef<ActionType>();
  const [open, setOpen] = useState(false);
  const [countdown, setCountdown] = useState(10);
  const userId = getCurrentUser()?.userId;

  useEffect(() => {
    let timer: NodeJS.Timeout;
    let countdownTimer: NodeJS.Timeout;

    if (open) {
      actionRef.current?.reload();
      // 设置倒计时
      countdownTimer = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            return 10;
          }
          return prev - 1;
        });
      }, 1000);

      // 设置自动刷新
      timer = setInterval(() => {
        actionRef.current?.reload();
      }, 10000);
    }

    return () => {
      if (timer) {
        clearInterval(timer);
      }
      if (countdownTimer) {
        clearInterval(countdownTimer);
      }
      setCountdown(10);
    };
  }, [open]);

  useEffect(() => {
    const openDownloadCenter = () => setOpen(true);
    eventBus.on(EVENT_OPEN_DOWNLOAD_CENTER, openDownloadCenter);
    return () => {
      eventBus.off(EVENT_OPEN_DOWNLOAD_CENTER, openDownloadCenter);
    };
  }, []);

  const handleDownload = (
    entity: PostBaobPcDownloadTaskList200DataListItem,
  ) => {
    fileDownloadByWindowOpen(entity.fileurl);
  };

  const columns: ProColumns<PostBaobPcDownloadTaskList200DataListItem>[] = [
    {
      title: "id",
      dataIndex: "id",
      align: "center",
      width: 80,
    },
    {
      title: "任务名",
      dataIndex: "title",
      align: "center",
    },
    {
      title: "进度",
      dataIndex: "progress",
      align: "center",
      render: (_, entity) => {
        return <Progress percent={Number(entity.progress)} />;
      },
    },
    {
      title: "导出时间",
      dataIndex: "create_time",
      align: "center",
    },
    {
      title: "下载链接",
      dataIndex: "filename",
      align: "center",
      render: (_, entity) => {
        if (entity.down_status !== "0") {
          if (entity.canDown === 1) {
            return (
              <Button type="primary" onClick={() => handleDownload(entity)}>
                下载文件
              </Button>
            );
          }
          return entity.filename;
        }
        return entity.filename;
      },
    },
    {
      title: "状态",
      dataIndex: "status",
      align: "center",
      render: (_, entity) => {
        if (entity.down_status !== "0") {
          if (entity.canDown === 1) {
            return <Tag color="success">已完成</Tag>;
          }
          return <Tag color="error">错误</Tag>;
        }
        return <Tag color="warning">执行中</Tag>;
      },
    },
    {
      title: "错误信息",
      dataIndex: "error_msg",
      align: "center",
      ellipsis: true,
    },
  ];

  const handleViewModal = () => {
    setOpen(true);
  };

  const handleCloseModal = () => {
    setOpen(false);
  };

  return (
    <>
      <Tooltip title="下载中心" color={globalToken.colorPrimary}>
        <CloudDownloadOutlined
          className="p-2 cursor-pointer hover:bg-[rgba(0,0,0,0.025)] text-2xl text-[#666]"
          onClick={handleViewModal}
        />
      </Tooltip>
      <Modal
        open={open}
        title={`下载中心 （ ${countdown} 秒后自动刷新）`}
        styles={{
          header: {
            marginBottom: 0,
            padding: "20px 24px",
            borderBottom: "1px solid #eee",
          },
          body: { borderRadius: "8px", overflow: "hidden" },
          content: { padding: "0 0 0 0" },
        }}
        width={1000}
        footer={false}
        onCancel={handleCloseModal}
      >
        <ProTable<
          PostBaobPcDownloadTaskList200DataListItem,
          PostBaobPcDownloadTaskListBody
        >
          params={{ user_id: userId }}
          columns={columns}
          actionRef={actionRef}
          search={false}
          options={false}
          scroll={{ y: 500 }}
          rowKey={(record) => record.id}
          request={(params) => {
            const { current, pageSize, ...rest } = params;
            return postBaobPcDownloadTaskList({
              ...rest,
              page: Number(current),
              page_size: Number(pageSize),
            }).then((res) => {
              const { list, total } = res.data || {};
              return {
                data: list,
                success: true,
                total,
              };
            });
          }}
          defaultSize="small"
          pagination={{
            position: ["bottomCenter"],
            showSizeChanger: true,
          }}
        ></ProTable>
      </Modal>
    </>
  );
};

export default HeaderDownload;
